import React from 'react';
import PropTypes from 'prop-types';

const Member = ({text, name, image}) => {
  return (
    <div className="member">
      <div className="avatar-block">
        <div className={`avatar ${image}`} />
      </div>
      <div className="text-block">
        <div className="text">{text}</div>
        <div className={`sign`}>
          <div className={image} />
        </div>
        <div className="name">{name}</div>
      </div>
    </div>
  );
};

export default Member;

Member.propTypes = {
  text: PropTypes.string,
  name: PropTypes.string,
};

Member.defaultProps = {
  text: "",
  name: "",
};



// WEBPACK FOOTER //
// ./src/pages/HomePage/components/Member.js